import React from 'react';

export default function BlogHomePage() {
	return (
		<div className="h-550 w-1/2">
			{/* 
     */}
			<div />
		</div>
	);
}
